import React, { useEffect } from 'react';
import './Spreadscommissions.css';

const SpreadsCommissions = () => {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="page-container">
      <div className="container">
        <button className="back-button" onClick={() => window.history.back()}>
          <span>←</span><span>Back to Home</span>
        </button>

        <h1>Spreads and Commissions</h1>
        <p className="subtitle">Transparent pricing with competitive spreads from 0.0 pips.</p>

        <div className="highlight-box">
          <h3>✨ Raw Spread Advantage</h3>
          <p>Experience true institutional-grade spreads starting from 0.0 pips on major currency pairs.</p>
        </div>

        <div className="section">
          <h2>Account Type Comparison</h2>
          <table>
            <thead>
              <tr>
                <th>Instrument</th>
                <th>Standard Account</th>
                <th>Raw Spread Account</th>
                <th>Professional Account</th>
              </tr>
            </thead>
            <tbody>
              <tr><td>EUR/USD</td><td>From 1.0 pips</td><td>From 0.0 pips + $7/lot</td><td>From 0.0 pips + $5/lot</td></tr>
              <tr><td>GBP/USD</td><td>From 1.2 pips</td><td>From 0.1 pips + $7/lot</td><td>From 0.1 pips + $5/lot</td></tr>
              <tr><td>USD/JPY</td><td>From 1.0 pips</td><td>From 0.0 pips + $7/lot</td><td>From 0.0 pips + $5/lot</td></tr>
              <tr><td>Gold</td><td>From 2.0 pips</td><td>From 0.5 pips + $7/lot</td><td>From 0.3 pips + $5/lot</td></tr>
            </tbody>
          </table>
        </div>

        <div className="section">
          <h2>Additional Fees</h2>
          <ul className="fee-list">
            <li>Deposit Fee: $0</li>
            <li>Withdrawal Fee: $0</li>
            <li>Inactivity Fee: $10/month (after 3 months)</li>
            <li>Currency Conversion: 0.5%</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default SpreadsCommissions;